import { render, staticRenderFns } from "./open-data-box.vue?vue&type=template&id=5f461e27&scoped=true"
import script from "./open-data-box.vue?vue&type=script&lang=js"
export * from "./open-data-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f461e27",
  null
  
)

export default component.exports